import { useCartContext } from '../../../context/CartContext/CartContext';
import { useNavigate } from 'react-router-dom';
import { MdDelete } from 'react-icons/md';
import { Scrollbars } from 'react-custom-scrollbars';
import ShopSideBar from '../../components/SideBar/ShopSideBar';
import cartPageStyle from './cart.module.scss';
import { Form } from 'react-bootstrap';

export interface CartProps {
  collapsedSidebar: boolean;
  setCollapsedSidebar: React.Dispatch<React.SetStateAction<boolean>>;
}

function Cart({ collapsedSidebar, setCollapsedSidebar }: CartProps) {
  // Get washing fee state from the global context
  const { cart, cartRemoveProduct, includeWashingFee, setIncludeWashingFee } =
    useCartContext();
  const navigate = useNavigate();

  // --- Price Calculation Logic ---
  const calculatePrices = () => {
    if (!cart) {
      return { baseTotal: 0, fee: 0, pdv: 0, finalTotal: 0 };
    }

    const baseTotal = cart.totalWithFactor;

    // The washing fee is now 10% of the base total (price with factor)
    const dynamicWashingFee = baseTotal * 0.1;
    const fee = includeWashingFee ? dynamicWashingFee : 0;

    const totalBeforePdv = baseTotal + fee;
    const pdv = totalBeforePdv * 0.2;
    const finalTotal = totalBeforePdv + pdv;

    return { baseTotal, fee, pdv, finalTotal };
  };

  const prices = calculatePrices();

  if (!cart) return null;

  return (
    <>
      <ShopSideBar
        collapsed={collapsedSidebar}
        setCollapsed={setCollapsedSidebar}
        heading="Dodatne informacije"
      >
        {cart.hasStartEndDates() && (
          <div className={cartPageStyle.reservationInfo}>
            <div className={cartPageStyle.infoRow}>
              <span>Broj dana:</span>
              <span>{cart.numberOfDays}</span>
            </div>
            <div className={cartPageStyle.infoRow}>
              <span>Multiplikator cene:</span>
              <span>{cart.priceFactor.toFixed(2)}x</span>
            </div>
          </div>
        )}
      </ShopSideBar>
      <div className="cs-content">
        <div className={cartPageStyle.wrapper}>
          <div className={cartPageStyle.header}>
            <h1 className={cartPageStyle.title}>Korpa</h1>
          </div>
          <div className={cartPageStyle.content}>
            <div className={cartPageStyle.products}>
              <Scrollbars>
                {cart.products.length > 0 ? (
                  cart.products.map((product) => (
                    <div key={product.id} className={cartPageStyle.product}>
                      <div className={cartPageStyle.imageWrapper}>
                        <img
                          src={product.getMainImageUrl() ?? ''}
                          alt={product.name}
                        />
                      </div>
                      <div className={cartPageStyle.info}>
                        <div className={cartPageStyle.name}>{product.name}</div>
                        <div className={cartPageStyle.price}>
                          {product.price.toFixed(2)}&nbsp;
                          {process.env.REACT_APP_DEFAULT_CURRENCY || 'RSD'}
                        </div>
                      </div>
                      <div className={cartPageStyle.actions}>
                        <button
                          className={cartPageStyle.deleteButton}
                          onClick={() => cartRemoveProduct(product.id)}
                        >
                          <MdDelete size={24} />
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>Vaša korpa je trenutno prazna.</p>
                )}
              </Scrollbars>
            </div>
            <div className={cartPageStyle.summary}>
              {/* --- NEW PRICE SUMMARY & TOGGLE --- */}
              <div className={cartPageStyle.washingFeeToggle}>
                <Form.Check
                  type="switch"
                  id="washing-fee-switch"
                  label="Dodaj naknadu za pranje"
                  checked={includeWashingFee}
                  onChange={(e) => setIncludeWashingFee(e.target.checked)}
                />
              </div>

              <div className={cartPageStyle.priceSummary}>
                <div className={cartPageStyle.priceRow}>
                  <span>Cena (sa faktorom):</span>
                  <span>
                    {prices.baseTotal.toFixed(2)}&nbsp;
                    {process.env.REACT_APP_DEFAULT_CURRENCY || 'RSD'}
                  </span>
                </div>
                <div className={cartPageStyle.priceRow}>
                  <span>Pranje (10%):</span>
                  <span>
                    {prices.fee.toFixed(2)}&nbsp;
                    {process.env.REACT_APP_DEFAULT_CURRENCY || 'RSD'}
                  </span>
                </div>
                <div className={cartPageStyle.priceRow}>
                  <span>PDV (20%):</span>
                  <span>
                    {prices.pdv.toFixed(2)}&nbsp;
                    {process.env.REACT_APP_DEFAULT_CURRENCY || 'RSD'}
                  </span>
                </div>
                <div
                  className={`${cartPageStyle.priceRow} ${cartPageStyle.summaryTotal}`}
                >
                  <span>Ukupna cena:</span>
                  <span>
                    {prices.finalTotal.toFixed(2)}&nbsp;
                    {process.env.REACT_APP_DEFAULT_CURRENCY || 'RSD'}
                  </span>
                </div>
              </div>

              <div className={cartPageStyle.actions}>
                <button
                  onClick={() => navigate('/checkout')}
                  className={cartPageStyle.checkoutButton}
                  disabled={cart.products.length === 0}
                >
                  Rezerviši
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Cart;
